import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	removeGoal: {
		id: 'servicedesk-sla-settings.metrics.metric.editable.form.goals.goal.fields.remove-goal-button.remove-goal',
		defaultMessage: 'Remove goal',
		description: 'label for Remove goal button',
	},
});
